import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { fontRoboto } from "@product/scmp-sdk";

import VideoRecorder from "./video-recorder.svg";

type VideoTitleContainerProps = {
  $isHeroVideo?: boolean;
};

export const VideoTitleContainer = styled.div<VideoTitleContainerProps>`
  ${props =>
    props.$isHeroVideo
      ? css`
          display: none;

          ${props.theme.breakpoints.up("tablet")} {
            display: flex;
            align-items: center;

            margin-block-start: 12px;
            margin-inline: 14px;
          }
        `
      : css`
          display: flex;

          margin-block-start: 12px;
          margin-inline: 20px;
          ${props.theme.breakpoints.up("tablet")} {
            margin-inline: 14px;
          }
        `}
`;

export const VideoTitle = styled.div`
  color: #6f6f6f;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 19px;
`;

export const StyledVideoRecorder = styled(VideoRecorder)`
  margin-inline-end: 8px;
`;
